import { GALLERY } from "@/data/gallery";

export default function Gallery({
  title = "Our Recent Work",
  eyebrow = "Real Projects",
  subtitle = "A look at real garage door repairs and installations we've completed for homeowners and businesses across Prosper and Collin County.",
  items = GALLERY,
}) {
  // Uniform grid that always fills evenly: 8 across 4 cols, or 6 across 3 cols.
  const wide = items.length > 6;
  const shown = items.slice(0, wide ? 8 : 6);
  const gridClass = wide
    ? "grid-cols-2 lg:grid-cols-4"
    : "grid-cols-2 sm:grid-cols-3";

  return (
    <section id="gallery" className="bg-slate-50 py-20 lg:py-28 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-red-600">
            {eyebrow}
          </p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900">
            {title}
          </h2>
          <p className="mt-4 text-lg text-slate-600">{subtitle}</p>
        </div>

        <div className={`mt-12 grid ${gridClass} gap-3 sm:gap-4`}>
          {shown.map((img, i) => (
            <figure
              key={img.src}
              className="group relative aspect-[4/3] overflow-hidden rounded-lg bg-slate-900 shadow-sm ring-1 ring-slate-200/60"
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                width="768"
                height="512"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/15 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all">
                <span className="text-sm font-bold text-white">{img.caption}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
